import { useEffect } from "react";
import Menubar from "../Menubar";
import GCWHubspot from "./GCWHubspot";

const GCWThankYou = () => {
    return (
        <>
            <Menubar
                whatsInIt={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#whatsinit"
                }
                howToJoin={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#howtojoin"
                }
                joinNow={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#gcwHubspotForm"
                }
            />
            <section className="bannerAreaN greyBackgroundN BannerDeatils">
                <div className="detailsPageSection">
                    <img
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
                        alt="corporate wellness"
                        className="img-responsive"
                        width="100%"
                        height="400"
                    />
                </div>
                <div className="BannerContent singleHeading">
                    <div className="container customCampaignContainer text-center">
                        <div className="section-heading text-center">
                            <h1 className="colorwhite no-br">
                                Get Ready for <br/>Global Corporate Virtual
                                Walkathon 2024
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className=" greyBackgroundN section-pdn">
                <div className="container customCampaignContainer greyBackgroundN">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-10 col-md-10 col-sm-10 mx-auto col-xs-12 ">
                            <p className="subHeading mb-5">
                                You will soon receive an email from <a href="mailto:globalwalkathon@vantagecircle.com"><strong>
                                    globalwalkathon@vantagecircle.com
                                </strong></a> with all details to provide your team details.
                                Please add this email <a href="mailto:globalwalkathon@vantagecircle.com"><strong>
                                    globalwalkathon@vantagecircle.com
                                </strong></a> so that our email does not land on spam.
                            </p>
                            <div className="subTextHeading text-center innerSpace">
                                What to expect from the Global Corporate Virtual
                                Walkathon:
                            </div>
                            <ul className="mainbullets pl-4">
                                <li>
                                    Form your team and compete with other teams
                                    from across the world.
                                </li>
                                <li>Multiactivity Challenges.</li>
                                <li>Access a health and fitness content.</li>
                                <li>Get a change to win exciting rewards.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default GCWThankYou;
